import React, { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router";
import ReactGA from 'react-ga';

import AuthPage from "pages/Components/auth/AuthPage";
import Footer from "core/Components/Footer";
import Header from "core/Components/Header";
import { NOOP } from "core/constants";
import { useAppState } from "core/contexts/AppContext";
import { GOOGLE_ANALYTICS_ID } from "core/config/config";

import Main from "pages/Main";

type Props = {
    showBreadcrumb: boolean,
    breadcrumbHandler: (showBreadcrumb: boolean) => void,
    footerMenu?: { menu: [any], side: [any], bottom: [any] },
    footerMenuHandler: (pages: any) => void,
};

const AppPage: React.FC<Props> = ({
    showBreadcrumb,
    breadcrumbHandler = NOOP,
    footerMenu = undefined,
    footerMenuHandler = NOOP,
}) => {
    const [appState] = useAppState();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const stage = params.get("stage");

    ReactGA.initialize(GOOGLE_ANALYTICS_ID);

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [location]);

    return (
        <div className="App">
            <Header stage={stage} footerMenuHandler={footerMenuHandler} breadcrumbHandler={breadcrumbHandler} />
            <Routes>
                <Route path={"/"} element={<Main stage={stage} showBreadcrumb={showBreadcrumb} />} />
                <Route path={"/auth/*"} element={<AuthPage />} />
                <Route path={"*"} element={<Main stage={stage} showBreadcrumb={showBreadcrumb} />} />
            </Routes>
            {!appState.loading && (
                <Footer footerMenu={footerMenu} />
            )}
        </div>
    );
}

export default AppPage;
